/**
 * The platform's active analysis configuration, as this app's pickers show it.
 *
 * The back-office stars one configuration as the active one, and Beon analyses with it when nobody
 * chose another (backend: modules/interviewAnalysisTypes/common/activeConfig.ts). So a picker here
 * starts on it and marks it — and never hides the rest: choosing another stays possible.
 */

/** A character and not a colour: it survives every theme, and a screen reader names it. */
export const ACTIVE_MARK = '★';

/** «★ Name» for the active configuration, the bare name for the rest. */
export function analysisConfigLabel(config) {
  if (!config) return '';

  return config.isActive ? `${ACTIVE_MARK} ${config.name}` : config.name;
}

/** The id of the active configuration among these, or null: never a guess at «some» one. */
export function activeConfigId(configs) {
  const active = (configs || []).find((config) => config && config.isActive);

  return active ? active.id : null;
}

/**
 * A page of configurations added to those a picker already holds, none repeated.
 *
 * The create-interview picker loads its options page by page, and the active one is put in first,
 * before any page arrives, so it can be preselected; without this it would show twice.
 */
export function mergeConfigs(current, incoming) {
  const held = current || [];
  const seen = new Set(held.map((config) => Number(config.id)));

  return [...held, ...(incoming || []).filter((config) => !seen.has(Number(config.id)))];
}
